<template>
  <div id="home" class="page">

    <v-banner v-if="home.banner"
              :banner="home.banner"
              id="banner"/>

    <v-section v-if="home.opening_hours"
               :title="home.opening_hours.title">
      <v-opening-hours v-if="home.opening_hours"
                       :opening-hours="home.opening_hours"
                       id="oeffnungszeiten"/>
    </v-section>

    <v-section v-if="home.news_items && home.news_items.news_items.length > 0"
               :title="home.news_items.title"
               :description="home.news_items.description"
               id="aktuelles"
               elevated>
      <v-news-items :news-items="home.news_items.news_items"></v-news-items>
    </v-section>

    <v-section v-if="home.text_image"
               id="unsere-praxis">
      <v-text-image :content="home.text_image"/>
    </v-section>

    <v-slider v-if="home.slider"
              :slides="home.slider.images"
              id="unser-team"/>

    <v-section v-if="home.services"
               :title="home.services.title"
               :description="home.services.description"
               id="unsere-leistungen"
               alt-layout>
      <v-services :services="home.services"/>
    </v-section>

    <v-section v-if="home.teasers"
               :title="home.teasers.title"
               :description="home.teasers.description"
               :footnote="home.teasers.footnote"
               id="unsere-behandlungen"
               elevated>
      <v-teaser :teasers="home.teasers.teasers"></v-teaser>
    </v-section>

  </div>
</template>

<script>
import query from '@/services/api/query';

export default {
  name: 'Home',
  data() {
    return {
      components: [],
      home: {},
    };
  },
  apollo: {
    home: query.home,
  },
  mounted() {

  },
  methods: {
    elevated(component) {
      this.components.push(component);
      return this.components.indexOf(component) % 2;
    },
  },
  components: {
    vSection: () => import('@/components/section'),
    vTeaser: () => import('@/components/teasers'),
    vBanner: () => import('@/components/banner'),
    vOpeningHours: () => import('@/components/opening-hours'),
    vServices: () => import('@/components/services'),
    vTextImage: () => import('@/components/text-image'),
    vSlider: () => import('@/components/image-slider'),
    vNewsItems: () => import('@/components/news-items'),
  },
};
</script>
